@if (formFieldControl.touched) {
  <div class="mt-10">
    @if (formFieldControl.hasError('required')) {
      <div class="error text-danger">Required field</div>
    }
    @if (formFieldControl.hasError('minlength')) {
      <div class="error text-danger">Min {{ formFieldControl.errors?.['minlength'].requiredLength }} symbols.</div>
    }
    @if (formFieldControl.hasError('maxlength')) {
      <div class="error text-danger">Max {{ formFieldControl.errors?.['maxlength'].requiredLength }} symbols.</div>
    }
    @if (formFieldControl.hasError('min')) {
      <div class="error text-danger">Min value is {{ formFieldControl.errors?.['min'].min }}.</div>
    }
    @if (formFieldControl.hasError('max')) {
      <div class="error text-danger">Max value is {{ formFieldControl.errors?.['max'].max }}.</div>
    }
  </div>
}
